import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, Row, Col, Button, Descriptions, Tooltip, Popconfirm, message } from 'antd';
import { FileAddOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import AdPackageTable from './adpackageTable';
import AddPackage from './modal/addpackage';
import AdOrderTable from './adOrderTable';
import moment from 'moment';
import { pathOr } from 'ramda';
import countriesInfo from '../../config/countriesInfo.json';

import { advertisementGetPackage, advertisementGetOrder, advertisementPackageDelete } from '../../modules/advertisement';

import './adpackagecard.css';

class AdPackageCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selected: null,
			selectedOrder: null,
			isModalShow: false,
			modalType: null,
			modalFrom: null,
			view: 'package',
			selectedPackageStatus: null,
		 }
	}

	componentDidMount() {
		const { advertisement } = pathOr({}, ['props', 'location', 'state'], this);
		if (advertisement){
			this.setState({selected: advertisement});
			this.getPackageStatus(advertisement);
		}
	}

	componentDidUpdate(prevProps) {
		const { advertisementPackageList } = this.props;
		const { selected } = this.state;
		if (JSON.stringify(prevProps.advertisementPackageList) !== JSON.stringify(advertisementPackageList) && advertisementPackageList){
			var selectedItem = advertisementPackageList && advertisementPackageList.length > 0
			? selected && selected._id
				? advertisementPackageList.find(d=>d._id===selected._id)
				: advertisementPackageList[0]
			: null;
			this.setState({selected: selectedItem});
			this.getPackageStatus(selectedItem);
		}
	}

	onSelect = (value) => {
		if(value){
			this.setState({selected: value});
			this.getPackageStatus(value);
		}
	}

	onSelectOrder = (value) => {
		const { advertisementPackageList } = this.props;
		const { selected } = this.state;
		var data = advertisementPackageList || [];
		var selectedItem = selected && selected._id ? data.find(d=>d._id===selected._id) : data.length > 0 ? data[0] : null;
		this.props.history.push(`/order/${value._id}`, {
			advertisement: selectedItem,
			order: value,
		})
	}

	toggleModal = (type, from) => {
		const { isModalShow } = this.state;
		this.setState({modalType: type, modalFrom: from});
		this.setState({ isModalShow: !isModalShow });
	}

	getPackageStatus = (item) => {
		if (item && item.startDate && item.endDate) {
			let currentTime = new Date().getTime();
			if (new Date(item.startDate).getTime() > currentTime){
				this.setState({selectedPackageStatus: 'comingSoon'});
			}else{
				if (new Date(item.endDate).getTime() > currentTime){
					this.setState({selectedPackageStatus: 'available'});
				}else{
					this.setState({selectedPackageStatus: 'expired'});
				}
			}
		}
	}

	confirmDeletePackage = (e) => {
		this.props.advertisementPackageDelete(this.state.selected._id)
		.then(() => {
			this.props.advertisementGetPackage().then((res) => {
				if (res.length > 0) {
					this.setState({selected: res[0]});
				} else {
					this.setState({selected: null});
				}
			})
			message.success('Remove package successfully');
		}).catch(() => {
			message.error('Fail to remove package');
		})
	}

	render() {
		const { loading, loadingOrder, advertisementPackageList, advertisementOrderList,userProfile } = this.props;
		const { selected, isModalShow, modalType, modalFrom, selectedOrder, selectedPackageStatus } = this.state;
		var data = advertisementPackageList || [];
		var selectedItem = selected && selected._id ? data.find(d=>d._id===selected._id) : data.length > 0 ? data[0] : null;
		var orders = selectedItem && selectedItem.packageId && advertisementOrderList ? advertisementOrderList.filter(d=>d.package===selectedItem.packageId) : [];
		orders = orders.map((item, i) => {
			let title = `${item.name}`;
			let status = selectedPackageStatus === 'comingSoon'
				? {type: 'warning', text: 'Pending'}
				: selectedPackageStatus === 'expired'
				? {type: 'default', text: 'Expired'}
				: item.inventory > 0 || item.free
				? {type: 'processing', text: 'Running'}
				: {type: 'success', text: 'Finished'};
			return ({...item, title, status});
		})
		const getDayText = (day) => {
			switch(day){
				case 0: return 'Sunday';
				case 1: return 'Monday';
				case 2: return 'Tuesday';
				case 3: return 'Wednesday';
				case 4: return 'Thursday';
				case 5: return 'Friday';
				case 6: return 'Saturday';
				default: return '';
			}
		}
		const packageItems = selectedItem && [
			{
				key: "title",
				label: "Title",
				children: selectedItem.title,
				span: 2,
			},
			{
				key: "packageId",
				label: "Package Id",
				children: selectedItem.packageId,
			},
			{
				key: "description",
				label: "Description",
				children: selectedItem.description,
				span: 3,
			},
			{
				key: "time",
				label: "Time Ranges",
				children: (
					<div className='timeRangeWrapper'>
						<span>00:00</span>
						<table className='timeRangesBox'>
							<tbody>
								<tr>
									{Array.from(Array(24).keys()).map((num, k) => <Tooltip key={k} title={`${num.toString().padStart(2, '0')}:00 - ${(num + 1).toString().padStart(2, '0')}:00`}><td className={`box ${selectedItem.time.includes(num) && 'selected'}`}></td></Tooltip>)}
								</tr>
							</tbody>
						</table>
						<span>24:00</span>
					</div>
				),
				span: 3,
			},
			{
				key: "day",
				label: "Date Ranges",
				children: (
					<div className='timeRangeWrapper'>
						<span>Sun</span>
						<table className='timeRangesBox'>
							<tbody>
								<tr>
									{Array.from(Array(7).keys()).map((num, k) => <Tooltip key={k} title={getDayText(num)}><td className={`box ${selectedItem.day.includes(num) && 'selected'}`}></td></Tooltip>)}
								</tr>
							</tbody>
						</table>
						<span>Sat</span>
					</div>
				),
				span: 3,
			},
			{
				key: "region",
				label: "Location Ranges",
				children: selectedItem.region && selectedItem.region.length > 0 ? selectedItem.region.map(r => countriesInfo.find(country => country.code === r) ? countriesInfo.find(country => country.code === r).name : r).join(', ') : '',
				span: 3,
			},
			{
				key: "cpm",
				label: "Cost-Per-Thousand Impressions(CPM)",
				children: selectedItem.cpm,
				span: 1,
			},
			{
				key: "placement",
				label: "Adv Placements",
				children: <span className='placement'>{selectedItem.placement}</span>,
				span: 2,
			},
			{
				key: "avaliableTime",
				label: "Available Time",
				children: selectedItem.startDate && selectedItem.endDate ? `${moment(selectedItem.startDate).format('YYYY-MM-DD')} to ${moment(selectedItem.endDate).format('YYYY-MM-DD')}` : '',
				span: 3,
			}
		]

		let canEdit = (userProfile && userProfile.user && userProfile.user.access.includes('advertisement:editor')) ? true : false;

		return (
			<Card className="adpackagecard">
				{ canEdit && <h3 className='title'>
					<div>
						<Button
						icon={<FileAddOutlined />}
						size='small'
						shape='circle'
						onClick={() => {
							this.toggleModal("add", "Package")}}
						style={{ marginRight: '10px', marginLeft: '10px'}}
						/>
						{/* <Button icon={<SearchOutlined />} size='small' shape='circle'/> */}
					</div>
				</h3>}
				<Row>
				<Col span={data.length > 0 ? 5 : 24}>
					<AdPackageTable data={data} loading={loading} selectedItem={selectedItem} model={'adpackage'} onSelect={this.onSelect}/>
				</Col>
				<Col span={data.length > 0 ? 19 : 0}>
					{selectedItem &&
					<div className='content'>
						<div className='description package'>
							<div className='info'>
								<Descriptions
									bordered
									size="small"
									title={
										<span>
										{`Package Detail`}

										{
											(canEdit) &&
											orders.length === 0 &&
											<Button type="link" icon={<EditOutlined />} onClick={() => {this.toggleModal("edit", "Package")}}/>
										}
										{ (canEdit) && <Popconfirm
											title="Delete package"
											description="Are you sure to delete this package?"
											onConfirm={this.confirmDeletePackage}
											okText="Yes"
											cancelText="No"
										>
											<Button className='btn-delete' type="link" danger icon={<DeleteOutlined />}/>
										</Popconfirm>}
										</span>
									}
									items={packageItems}
								/>
							</div>
							<div className='order'>
								<div className='title'>Orders
								{(canEdit) && <Button
									icon={<FileAddOutlined />}
									size='default'
									type="link"
									onClick={() => {
										this.toggleModal("add", "Order")}}
									style={{ float: 'right', color: 'var(--text-primary)'}}
								/>}
								</div>
								<AdOrderTable data={orders} loading={loadingOrder} selectedItem={selectedOrder} onSelect={this.onSelectOrder}/>
							</div>
						</div>
					</div>
					}
				</Col>
				</Row>
				<AddPackage
					toggleModal={this.toggleModal}
					showModal={isModalShow}
					modalType={modalType}
					modalFrom={modalFrom}
					selected={modalFrom === 'Package' ? selectedItem : selectedOrder}
					defaultPackage={modalFrom === 'Package' || !selectedItem ? null : selectedItem.packageId}
		  		/>
			</Card>
		);
	}
}

const mapStateToProps = state => ({
	router: state.router,
	userTheme: state.user.userTheme,
	selectedOrganization: state.user.selectedOrganization,
	advertisementPackageList: state.advertisement.advertisementPackageList,
	advertisementOrderList: state.advertisement.advertisementOrderList,
	userProfile: state.user.userProfile
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
      		advertisementGetPackage,
			advertisementGetOrder,
			advertisementPackageDelete,
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdPackageCard));
